import { AppEndPointModel } from "@models/endpoint-url.model";
const data = require('@assets/appsettings.json');

export class AppConfig {
    public settings = new AppEndPointModel();
    constructor() {  
        this.settings = data.AppSettings;    
        window.endpointFSPrefix = this.settings.FieldServiceEndpointPrefix;
        window.endpointPaymentPrefix = this.settings.PaymentProcessorCardConnectEndPoint;
        window.endpointReportPrefix = this.settings.ReportServiceUrl;
        window.googleMapsKey = this.settings.GoogleMapAPIKey;
    }
    public getApiUrl(){
        return this.settings.FieldServiceEndpointPrefix;
    }
    public getEndPoints(): AppEndPointModel {
        return this.settings;
    }
}

declare global {
    interface Window {
        endpointFSPrefix: any;
        endpointIMPrefix: any;
        endpointPaymentPrefix: any;
        endpointQBPrefix: any;
        endpointReportPrefix: any;
        googleMapsKey: any;
    }
}